import React from 'react';
import { Box, Container, Grid, Typography, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

function Awareness() {
    return (
        <Box
            id="awareness"
            sx={{
                width: '100%',
                backgroundColor: '#141414',
                pt: 6,
                pb: 3,
            }}
        >
            <Container maxWidth="lg">
                <Grid container alignItems="center" spacing={4}>
                    {/* Image Section */}
                    <Grid item xs={12} sm={6}>
                        <Box
                            component="img"
                            src="/img/awareness.jpg" // Replace with actual image path
                            alt="Cybersecurity Awareness"
                            sx={{
                                width: '100%',
                                borderRadius: 2,
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            }}
                        />
                    </Grid>

                    {/* Content Section */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ color: 'white', textAlign: 'left' }}>
                            {/* Subtitle */}
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    color: '#1e88e5', // Blue color for subtitle
                                    fontWeight: 'bold',
                                    mb: 1,
                                }}
                            >
                                Empower Yourself with Cybersecurity Awareness
                            </Typography>

                            {/* Heading */}
                            <Typography
                                variant="h2"
                                sx={{
                                    fontSize: '32px',
                                    fontWeight: '600',
                                    mb: 2,
                                }}
                            >
                                Stay Vigilant and Secure
                            </Typography>

                            {/* Paragraph */}
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    mb: 2,
                                }}
                            >
                                Our cybersecurity awareness training equips you with the knowledge and skills to protect yourself and your organization from evolving threats.
                            </Typography>

                            {/* Bullet List */}
                            <List>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Recognize and respond to phishing attacks."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Understand the importance of secure passwords."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Learn to identify social engineering tactics."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Discover best practices for data protection."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                                <ListItem sx={{ py: 0 }}>
                                    <ListItemIcon sx={{ minWidth: '30px' }}>
                                        <CircleIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Stay updated on the latest cyber threats."
                                        primaryTypographyProps={{ color: 'rgba(255, 255, 255, 0.85)' }}
                                    />
                                </ListItem>
                            </List>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}

export default Awareness;
